import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, space } from '../../theme/tokens';

export const RecommendationsWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
`;

export const RecommendationsTitle = styled.h2`
  font-family: ${fonts.heading};
  font-size: ${primitives.typography['scale-text']['scale-text-900']};
  font-weight: ${fonts.weight.normal};
  letter-spacing: ${primitives.typography.tracking.tight};
  line-height: ${primitives.typography.lineHeight.tight};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const CenteredGrid = styled.div<{
  $columns: number;
  $mobileColumns: number;
  $rowGap?: string;
}>`
  --cols: ${({ $mobileColumns }) => $mobileColumns};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${({ $rowGap }) => $rowGap ?? space['space-600']} ${space['space-600']};
  margin-bottom: ${space['space-2000']};

  > * {
    flex: 0 0 calc((100% - (var(--cols) - 1) * ${space['space-600']}) / var(--cols));
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    --cols: ${({ $columns }) => $columns};
  }
`;

export const GridStack = styled.div<{ $rowGap?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${space['space-500']};
  width: 100%;
  margin-bottom: ${space['space-2000']};

  ${CenteredGrid} {
    margin-bottom: 0;
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    gap: ${({ $rowGap }) => $rowGap ?? space['space-600']};
  }
`;

export const FullWidthCell = styled.div<{ $columns: number }>`
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    --cols: ${({ $columns }) => $columns};
    width: calc((100% - (var(--cols) - 1) * ${space['space-600']}) / var(--cols));
  }
`;

export const GridHeading = styled.p<{ $size?: 'base' | 'large' }>`
  margin: 0 0 ${({ $size }) => ($size === 'large' ? space['space-1000'] : space['space-600'])};
  text-align: center;
  font-family: ${fonts.heading};
  font-weight: ${fonts.weight.normal};
  font-size: ${fonts.size['2xl']};
  line-height: ${primitives.typography.lineHeight.tight};
  color: ${semantic.text.primary};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${({ $size }) => ($size === 'large' ? fonts.size['3xl'] : fonts.size['2xl'])};
  }
`;

export const GridHeadingSecondary = styled.span`
  color: ${semantic.text.secondary};
`;
